import React from 'react';
import LayoutHome from '../../../components/layout/LayoutHome';
import { Card, Layout, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const { Text, Title } = Typography;

const VentanaVerificandoCaja = () => {
    return (
        <LayoutHome>
            <Layout style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center', background: '#f8fafc' }}>

                <div style={{ maxWidth: '480px', width: '100%', padding: '0 20px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}>
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: '24px',
                            textAlign: 'center',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                        }}
                    >
                        <div style={{ background: '#f0fdfa', width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                            <LoadingOutlined style={{ fontSize: '36px', color: '#22BABB' }} spin />
                        </div>

                        <Title level={3} style={{ color: '#0f172a', marginBottom: '8px', fontWeight: '800' }}>
                            Verificando Caja
                        </Title>

                        <Text style={{ fontSize: '15px', color: '#64748b', display: 'block', marginBottom: '10px' }}>
                            Conectando de forma segura y sincronizando tu turno...
                        </Text>
                    </Card>
                </div>

            </Layout>
        </LayoutHome>
    )
}

export default VentanaVerificandoCaja;